module.exports = __webpack_public_path__ + "files/662bc54992ff61cac69994f61e617f9b.png";